import React, { useState } from 'react';
import setHTML from '@codedrop/utils/esm/utils';

const Form = ({
  formName,
  modifierClass,
  formSubmitText,
  formFields,
  formSuccess,
  formFail,
  callBack
}) => {
  const [showContent, setShowContent] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  let initialState = {
    errors: null
  };
  const [state, setState] = useState(initialState);
  formFields.forEach(field => {
    if (field.type === 'select') {
      initialState[field.name] = {
        value: field.options[0].value,
        required: field.required
      };
    } else {
      initialState[field.name] = {
        value: field.value,
        required: field.required
      };
    }
  });

  const handleStateChange = ({
    target
  }) => {
    const stateObject = {
      [target.name]: {
        value: target.value,
        required: target.hasAttribute('required')
      }
    };
    setState({ ...state,
      ...stateObject
    });
  };

  const encode = data => {
    const dataSets = Object.keys(data).filter(key => data[key] && key !== 'errors').map(key => {
      let value = data[key];

      if (typeof value === 'object' && value.hasOwnProperty('value')) {
        value = value.value;
      }

      if (!value) return;
      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    });
    return dataSets.filter(Boolean).join('&');
  };

  let errors = [];

  const handleSubmit = e => {
    e.preventDefault();
    Object.keys(state).forEach(key => {
      if (key !== 'errors' && state[key].required && (state[key].value === undefined || state[key].value === '')) {
        errors.push("The ".concat(key, " field is required!"));
      }
    });
    const errorsObject = {
      errors: errors
    };
    setState({ ...state,
      ...errorsObject
    });
    const formVars = {
      'form-name': formName
    };
    const body = { ...formVars,
      ...state
    };

    if (errors.length === 0) {
      fetch('/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: encode(body)
      }).then(result => {
        setShowContent(false);

        if (result.ok) {
          setShowSuccess(true);
        } else {
          setShowSuccess(false);
        }
      }).catch(() => {
        setShowContent(false);
        setShowSuccess(false);
      });
    } else {
      setShowContent(false);
      setShowSuccess(false);
    }
  };

  return /*#__PURE__*/React.createElement("div", null, showContent ? /*#__PURE__*/React.createElement("form", {
    name: formName,
    onSubmit: e => handleSubmit(e, state),
    "data-netlify": "true",
    "data-netlify-honeypot": "bot-field",
    className: modifierClass
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "form-name",
    value: formName
  }), formFields.map(field => {
    switch (field.type) {
      case 'select':
        return /*#__PURE__*/React.createElement("div", {
          className: "form__input ".concat(field.wrapperClass),
          key: "".concat(formName, "-").concat(field.name)
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: field.id,
          className: field.labelClass
        }, field.label, field.required && /*#__PURE__*/React.createElement("span", null, " (required)")), /*#__PURE__*/React.createElement("select", {
          defaultValue: field.options[0].value,
          onChange: handleStateChange,
          name: field.name,
          className: "input ".concat(field.className),
          id: field.id,
          required: field.required
        }, field.options.map((option, key) => {
          return /*#__PURE__*/React.createElement("option", {
            value: option.value,
            key: "".concat(field.id, "-").concat(key)
          }, option.name);
        })), field.description && /*#__PURE__*/React.createElement("div", {
          className: 'text--xxs text--left'
        }, setHTML(field.description)));
        break;

      case 'textarea':
        return /*#__PURE__*/React.createElement("div", {
          className: "form__input ".concat(field.wrapperClass),
          key: "".concat(formName, "-").concat(field.name)
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: field.id,
          className: field.labelClass
        }, field.label, field.required && /*#__PURE__*/React.createElement("span", null, " (required)")), /*#__PURE__*/React.createElement("textarea", {
          defaultValue: state[field.name].value,
          onChange: handleStateChange,
          name: field.name,
          placeholder: field.placeholder,
          className: "input ".concat(field.className),
          id: field.id,
          required: field.required
        }), field.description && /*#__PURE__*/React.createElement("div", {
          className: 'text--xxs text--left'
        }, setHTML(field.description)));
        break;

      default:
        return /*#__PURE__*/React.createElement("div", {
          className: "form__input ".concat(field.wrapperClass),
          key: "".concat(formName, "-").concat(field.name)
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: field.id,
          className: field.labelClass
        }, field.label, field.required && /*#__PURE__*/React.createElement("span", null, " (required)")), /*#__PURE__*/React.createElement("input", {
          defaultValue: state[field.name].value,
          onChange: handleStateChange,
          type: field.type,
          name: field.name,
          placeholder: field.placeholder,
          className: "input ".concat(field.className),
          id: field.id,
          required: field.required
        }), field.description && /*#__PURE__*/React.createElement("div", {
          className: 'text--xxs text--left'
        }, setHTML(field.description)));
        break;
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "submit",
    className: "button",
    value: formSubmitText
  })) : /*#__PURE__*/React.createElement("div", {
    className: "form__messages"
  }, showSuccess ? /*#__PURE__*/React.createElement("div", {
    className: "form__message form__message--success form__message--show"
  }, /*#__PURE__*/React.createElement("h3", null, setHTML(formSuccess.title)), /*#__PURE__*/React.createElement("p", null, setHTML(formSuccess.content)), /*#__PURE__*/React.createElement("button", {
    className: "button button--primary",
    onClick: callBack
  }, "Sounds Good")) : /*#__PURE__*/React.createElement("div", {
    className: "form__message form__message--error form__message--show"
  }, /*#__PURE__*/React.createElement("h3", null, setHTML(formFail.title)), /*#__PURE__*/React.createElement("p", null, setHTML(formFail.content)), /*#__PURE__*/React.createElement("ul", {
    className: "text--error"
  }, state.errors ? state.errors.map((error, index) => /*#__PURE__*/React.createElement("li", {
    key: "error-".concat(index)
  }, error)) : ''), /*#__PURE__*/React.createElement("button", {
    className: "button button--primary",
    onClick: () => {
      setShowContent(true);
      setShowSuccess(false);
    }
  }, "Got It"))));
};

Form.displayName = 'Form Dynamic';
Form.defaultProps = {
  formName: 'test-form',
  modifierClass: '',
  formSubmitText: 'Schedule a chat',
  formFields: [{
    id: 'test-name-input',
    name: 'name',
    label: 'Name',
    type: 'text',
    placeholder: '',
    className: 'input--icon icon--user',
    wrapperClass: '',
    labelClass: ''
  }],
  formSuccess: {
    title: 'Awesome',
    content: 'Request has been sent.'
  },
  formFail: {
    title: 'Boo',
    content: 'Request could not be sent.'
  },
  callBack: () => {}
};
export default Form;